import { ApiProperty } from "@nestjs/swagger";

export class ProductBarcodeRequest {
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    itemId: number;
}